import _ from 'lodash';
import { mapSDKConfigToCustomChartConfig } from '../utils/custom-chart-config-adaptor.util';
export const updateCharVizRefColumnProperties = (chartVizRef, viz) => {
    const updatedColumnProperties = viz.vizProp.columnProperties;
    chartVizRef.current = {
        ...chartVizRef.current,
        vizProp: {
            ...chartVizRef.current.vizProp,
            columnProperties: _.cloneDeep(updatedColumnProperties),
        },
    };
};
export const updateChartVizRefColumns = (chartVizRef, viz) => {
    chartVizRef.current = {
        ...chartVizRef.current,
        columns: _.cloneDeep(viz.columns),
    };
};
export const hasColumnNameChanged = (prevColumns, nextColumns) => {
    if (!prevColumns || !nextColumns)
        return false;
    return prevColumns.some(prevVizCol => {
        if (!prevVizCol.column?.id)
            return false;
        const matchingNext = nextColumns.find(n => n.column?.id === prevVizCol.column?.id);
        return matchingNext?.column?.name !== prevVizCol.column?.name;
    });
};
export const updateChartVizRefConfig = (chartVizRef, sdkChartConfig) => {
    chartVizRef.current = {
        ...chartVizRef.current,
        config: {
            ...chartVizRef.current.config,
            customChartConfig: mapSDKConfigToCustomChartConfig(sdkChartConfig),
        },
    };
};
//# sourceMappingURL=custom-chart.component.util.js.map